function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRequire.register("eZpnS", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("6r15D"), import.meta.url).toString();

});

parcelRequire.register("8NNKi", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("iI8az"), import.meta.url).toString();

});

parcelRequire.register("k5z4A", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("18Bji"), import.meta.url).toString();

});

parcelRequire.register("flovY", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("9YlsY"), import.meta.url).toString();

});

parcelRequire.register("5AxGM", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("f77RV"), import.meta.url).toString();

});

parcelRequire.register("25c9V", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("jpXoe"), import.meta.url).toString();

});

parcelRequire.register("3e7ho", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("hbNjC"), import.meta.url).toString();

});

parcelRequire.register("cuiEO", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("czTZJ"), import.meta.url).toString();

});

parcelRequire.register("8JYd6", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("iQpQY"), import.meta.url).toString();

});

parcelRequire.register("bmmz0", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("1fZlq"), import.meta.url).toString();

});

parcelRequire.register("5PfYl", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("jsdk0"), import.meta.url).toString();

});

parcelRequire.register("dBUyq", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("7KQy2"), import.meta.url).toString();

});

parcelRequire.register("9o09i", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("1Drnw"), import.meta.url).toString();

});

parcelRequire.register("KwfgD", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("kpAjF"), import.meta.url).toString();

});

parcelRequire.register("47DtA", function(module, exports) {

module.exports = new URL((parcelRequire("27Lyk")).resolve("dsQYz"), import.meta.url).toString();

});

parcelRequire.register("DkdI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $076353eda2b1ccde$export$2e2bcd8739ae039);
var $076353eda2b1ccde$export$2e2bcd8739ae039 = {
    "samples": true,
    "production": ""
};

});

parcelRequire.register("dUT0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $a21b2ca73d4a80ca$export$2e2bcd8739ae039);

var $DkdI3 = parcelRequire("DkdI3");
var $a21b2ca73d4a80ca$export$2e2bcd8739ae039 = {
    "samples": (0, $DkdI3.default)["production"] == "" && (0, $DkdI3.default)["samples"] ? true : false,
    "socketProxyUrl": `${(0, $DkdI3.default)["production"]}/`,
    "proxyUrl": `${(0, $DkdI3.default)["production"]}/api`,
    "proxyAppUrl": `${(0, $DkdI3.default)["production"]}/app`,
    "backendUrl": `http://localhost:1997/officeride/api`,
    "nammaoorutaxi": "https://vmroutes.vmmaps.com/app/",
    "livedrivers": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequest.php?notime=1&requestid=`,
    "ridelaterrequests": `https://api.not.nammaoorutaxi.com/cabs/ridelaterAPIrequests.php`,
    "ride_request_now_selective": `https://api.not.nammaoorutaxi.com/cabs/dispatchrequesttodriver.php`,
    "ridelatersolverroutes": `https://nammaoorutaxi.com/vrs/solver/rideshare/solve`,
    "driverlists": `https://api.not.nammaoorutaxi.com/cabs/list/driversdetails.php`,
    "driverapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-default.php?token=fsdfsdfsdfsdfdfs`,
    "driverofficerideapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-officeride.php?token=fsdfsdfsdfsdfdfs`,
    "driveraccountapprovedetails": `https://api.not.nammaoorutaxi.com/cabs/manage-account.php?token=fsdfsdfsdfsdfdfs`,
    "driversbasedetails": `https://api.not.nammaoorutaxi.com/cabs/list/fetchDrivers.php`,
    "mapmatching": `https://nammaoorutaxi.com/livetracking/api/get?id=`,
    "gps_tracking_local": `http://127.0.0.1:1253/gps-tracker/get-historical-data`,
    "gps_tracking": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-historical-data`,
    "gps_tracking_total": `https://gpstracker.nammaoorutaxi.com/gps/gps-tracker/get-total-data`,
    "createridelaterrequest": `https://api.not.nammaoorutaxi.com/cabs/createridelaterrequest.php`
};

});

var $db72896a27a278ae$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"hX6BM":"privacy.bc4d721e.js","6r15D":"address_icon.6a4da000.svg","iI8az":"close_icon.9ca90630.png","18Bji":"contact_address_icon.61db59f3.svg","9YlsY":"contact_email_icon.a51be1b5.svg","f77RV":"contact_phone_icon.79cfee7b.svg","jpXoe":"contact_side_icon.659e2df9.png","hbNjC":"email_icon.817ed231.svg","czTZJ":"hamburger_icon.a7ee304b.png","iQpQY":"phone_icon.ecb0a97d.svg","1fZlq":"success_icon.b097ec65.svg","jsdk0":"vm_routes_logo.090c7270.svg","7KQy2":"security.d60ccb91.svg","1Drnw":"https.a72ef8a4.svg","kpAjF":"facebook.354a082e.svg","dsQYz":"linkedIn.5636bdaf.svg"}'));


var $eZpnS = parcelRequire("eZpnS");

var $8NNKi = parcelRequire("8NNKi");

var $k5z4A = parcelRequire("k5z4A");

var $flovY = parcelRequire("flovY");

var $5AxGM = parcelRequire("5AxGM");

var $25c9V = parcelRequire("25c9V");

var $3e7ho = parcelRequire("3e7ho");

var $cuiEO = parcelRequire("cuiEO");

var $8JYd6 = parcelRequire("8JYd6");

var $bmmz0 = parcelRequire("bmmz0");

var $5PfYl = parcelRequire("5PfYl");

var $dBUyq = parcelRequire("dBUyq");

var $9o09i = parcelRequire("9o09i");

var $KwfgD = parcelRequire("KwfgD");

var $47DtA = parcelRequire("47DtA");

var $DkdI3 = parcelRequire("DkdI3");

var $dUT0w = parcelRequire("dUT0w");
class $105fe560979385a8$var$Page {
    constructor(globalStore, container){
        this.globalStore = globalStore || {};
        this.container = container || document.querySelector(".project-main");
        this._init();
    }
    _init = async ()=>{
        this.ui = await this.makelandingUi();
        this.addEvents(this.ui);
    };
    makelandingUi = async ()=>{
        this.container.innerHTML = `
    <div class="landing-page-main-container">
    <div class="landing-page-navbar">
        <a href="${(0, $DkdI3.default).production}/"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($5PfYl))}"></a>
        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($cuiEO))}" width="48" height="48" class="hamburger-icon">
        <div class="navbar-link-header">
            <a class="navbar-link navbar-active-link" id="home-nav">Privacy Policy</a>
            <a class="navbar-link contact-us-menu-button" id="contact-nav">Contact Us</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/client" id="client-nav">Client</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/vendors" id="vendor-nav">Vendor</a>
            <a class="navbar-link" href="${(0, $DkdI3.default).production}/operator" id="operator-nav">Operator</a>
        </div>
    </div>

    <hr class="navbar-border">

    <div class="home-page-container" >

        <div class="home-container">
            <div class="home-container significance mt-60">
                <p class="about-text significance" style="
                    color: #212121;
                    text-align: center;
                    font-size: 2.5rem;
                    line-height: 1.5;">
                    <span class="about-text significance highlight">Privacy Policy</span>
                </p>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> respects the privacy of our users and is committed to protecting it through our compliance with this policy. This policy describes the types of information we may collect from you or that you may provide when you use our services and our practices for collecting, using, maintaining, protecting, and disclosing that information.
                </p>
                <br></br>
                <h3 class="about-text highlight">License and Ownership</h3>
                <br></br>
                <p class="about-text">
                    All content on the site is owned by <span class="about-text highlight">
                         VM Routes
                    </span> and is subject to copyright, patent, trademark, and various other intellectual property rights.
                </p>
                <br></br>
                <h3 class="about-text highlight">Disclaimer of Warranties & Limitation of Liability</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> provides the website, Employee App, and Driver App on an &quot;as is&quot; basis without any express or implied warranties. <span class="about-text highlight">
                         VM Routes
                    </span> will not be liable for any damages arising from the use of the site, Employee App, or Driver App.
                </p>
                <br></br>
                <h3 class="about-text highlight">Restrictions</h3>
                <br></br>
                <p class="about-text">
                    You are prohibited from engaging in certain activities that violate these Terms of Use or applicable laws.
                </p>
                <br></br>
                <h3 class="about-text highlight">Termination</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> may terminate your access to the site, Employee App, or Driver App at any time.
                </p>
                <br></br>
                <h3 class="about-text highlight">Information We Collect</h3>
                <br></br>
                <p class="about-text">
                    We collect several types of information from and about users of our services, including information:
                </p>
                <ul class="about-text">
                    <li>Personal information by which you may be identified, such as name, postal address, email address, and telephone number (&quot;personal information&quot;).</li>
                    <li>Information about you that does not individually identify you.</li>
                    <li>Information about your internet connection, the equipment you use to access our services, and usage details.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Employee App</h3>
                <br></br>
                <p class="about-text">
                    For users of the Employee App, we collect:
                </p>
                <ul class="about-text">
                    <li>Name, email address, and contact information.</li>
                    <li>Current location data (for display purposes only, not stored).</li>
                    <li>Usage details automatically as you navigate through the app, information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Driver App</h3>
                <br></br>
                <p class="about-text">
                    For users of the Driver App, we collect:
                </p>
                <ul class="about-text">
                    <li>Name, email address, and contact information.</li>
                    <li>Location data for route tracking and navigation purposes.</li>
                    <li>Camera access for documenting odometer readings and trip Sheet verification (photos are stored securely).</li>
                    <li>Usage details automatically as you navigate through the app, information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">How We Collect Information</h3>
                <br></br>
                <p class="about-text">
                    We collect this information:
                </p>
                <ul class="about-text">
                    <li>Directly from you when you provide it to us.</li>
                    <li>Automatically as you navigate through the site and apps. Information collected automatically may include usage details, IP addresses, and information collected through cookies and other tracking technologies.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">How We Use Your Information</h3>
                <br></br>
                <p class="about-text">
                    We use information that we collect about you or that you provide to us, including any personal information:
                </p>
                <ul class="about-text">
                    <li>To present our services and its contents to you.</li>
                    <li>To provide you with information, products, or services that you request from us.</li>
                    <li>To fulfill any other purpose for which you provide it.</li>
                    <li>For any other purpose with your consent.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Disclosure of Your Information</h3>
                <br></br>
                <p class="about-text">
                    We may disclose aggregated information about our users and information that does not identify any individual without restriction. We may disclose personal information that we collect or you provide as described in this privacy policy:
                </p>
                <ul class="about-text">
                    <li>To our subsidiaries and affiliates.</li>
                    <li>To contractors, service providers, and other third parties we use to support our business.</li>
                    <li>To fulfill the purpose for which you provide it.</li>
                    <li>For any other purpose disclosed by us when you provide the information.</li>
                    <li>With your consent.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Your Rights</h3>
                <br></br>
                <p class="about-text">
                    You have the right to:
                </p>
                <ul class="about-text">
                    <li>Access and receive a copy of the personal information we hold about you.</li>
                    <li>Request correction of the personal information that we hold about you.</li>
                    <li>Request deletion of your personal information.</li>
                    <li>Object to the processing of your personal information.</li>
                    <li>Request the transfer of your personal information to another party.</li>
                </ul>
                <br></br>
                <h3 class="about-text highlight">Data Security</h3>
                <br></br>
                <p class="about-text">
                    We have implemented measures designed to secure your personal information from accidental loss and from unauthorized access, use, alteration, and disclosure.
                </p>
                <br></br>
                <h3 class="about-text highlight">Changes to Our Privacy Policy</h3>
                <br></br>
                <p class="about-text">
                    We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page.
                </p>
                <br></br>
                <h3 class="about-text highlight">Contact Information</h3>
                <br></br>
                <p class="about-text">
                    To ask questions or comment about this privacy policy and our privacy practices, contact us at: support@vmtrackers.com.
                </p>
                <br></br>
                <h3 class="about-text highlight">Limitation of Liability</h3>
                <br></br>
                <p class="about-text">
                    <span class="about-text highlight">
                         VM Routes
                    </span> will not be liable for any indirect, punitive, or consequential damages.
                </p>
                <br></br>
                <h3 class="about-text highlight">Indemnity</h3>
                <br></br>
                <p class="about-text">
                    You agree to indemnify <span class="about-text highlight">
                         VM Routes
                    </span> against any claims arising from your use of the site, Employee App, Driver App, or violation of these Terms.
                </p>
                <br></br>
                <h3 class="about-text highlight">Dispute Resolution</h3>
                <br></br>
                <p class="about-text">
                    Any dispute will be governed by the Arbitration and Conciliation Act, 1966.
                </p>
                <br></br>
                <h3 class="about-text highlight">Jurisdiction</h3>
                <br></br>
                <p class="about-text">
                    These Terms are governed by the laws of India and are subject to the jurisdiction of the courts in Delhi, India.
                </p>
                <br></br>
                <h3 class="about-text highlight">Severability</h3>
                <br></br>
                <p class="about-text">
                    If any provision of these Terms is found invalid, the remaining provisions will continue to be valid.
                </p>
                <br></br>
                <h3 class="about-text highlight">Complete Agreement</h3>
                <br></br>
                <p class="about-text">
                    These Terms constitute the entire agreement between you and <span class="about-text highlight">
                         VM Routes
                    </span>.
                </p>
                <br></br>
                <h3 class="about-text highlight">Waiver</h3>
                <br></br>
                <p class="about-text">
                    Any failure by <span class="about-text highlight">
                         VM Routes
                    </span> to enforce these Terms does not constitute a waiver of such rights.
                </p>
                <br></br>
                <h3 class="about-text highlight">Disclaimers</h3>
                <br></br>
                <p class="about-text">
                    The services of <span class="about-text highlight">
                         VM Routes
                    </span> are subject to terms and conditions, and the company disclaims any liability for the use of its services.
                </p>
            </div>
        </div>

        <div class="landing-footer-container">
            <div class="landing-footer-details-tab">

                <div class="footer-company-details-tab">
                    <img src="${0, (/*@__PURE__*/$parcel$interopDefault($5PfYl))}">
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($eZpnS))}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($8JYd6))}"> +91 90921 90321</p>
                    <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($3e7ho))}"> reachus@virtualmaze.co.in</p>
                </div>
    
                <div class="footer-legal-tab">
                    <p class="footer-tab-title">Legal</p>
                    <p class="footer-tab-body"><a href="${(0, $DkdI3.default).production}/terms-and-conditions" target="_blank">Terms and Conditions</a></p>
                    <p class="footer-tab-body"><a href="#terms-header-container">Privacy Policy</a></p>
                    <p class="footer-tab-body"><a href="${(0, $DkdI3.default).production}/cookie-policy" target="_blank">Cookie Policy</a></p>
                </div>
    
                <div class="footer-help-tab">
                    <p class="footer-tab-title">Help</p>
                    <p class="footer-tab-body contact-us-menu-button">Contact Us</p>
                    <div class="footer-icons-container">
                        <a href="https://www.linkedin.com/company/99296180/admin/feed/posts/" target="_blank"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($47DtA))}"></a>
                        <a href="https://www.facebook.com/vmroutes" target="_blank"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($KwfgD))}"></a>

                    </div>
                </div>

                <div class="footer-help-tab">
                    <p class="footer-tab-title">Security</p>
                    <div class="footer-icons-container">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($dBUyq))}">
                        <img src="${0, (/*@__PURE__*/$parcel$interopDefault($9o09i))}">
                    </div>
                </div>

            </div>
            
            <p class="copyright-footer">Copyright © 2024 . VirtualMaze Softsys Private Limited</p>
        </div>

    </div>

    <div class="contact-us-page-container" style="display:none;">
        <div class="contact-us-form-container">
            <div class="contact-form-left-container">
                <p class="contact-form-top-text">Do you have more questions about Agency Portal?</p>
                <p class="contact-form-middle-text"><span>Say Hi!</span> and leave us a message</p>
                <p class="contact-form-bottom-text">Our team will contact you as soon as possible</p>

                <form id="contactForm">
                    <div class="contact-input-container">
                    <label for="fullName">Full Name:</label>
                    <input type="text" id="fullName" name="fullName" placeholder="Ramesh" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="email">Email Address:</label>
                    <input type="email" id="email" name="email" placeholder="ezioauditore@gmail.com" class="contact-input" required>
                    </div>
    
                    <div class="contact-input-container">
                    <label for="phone">Phone Number:</label>
                    <input type="tel" id="phone" name="phone" placeholder="98765 43210" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="subject">Subject:</label>
                    <input type="text" id="subject" name="subject" placeholder="Enquiry on software" class="contact-input" required>
                    </div>
                
                    <div class="contact-input-container">
                    <label for="message">Message:</label>
                    <input type="text" id="message" name="message" placeholder="Write a message" class="contact-input" required>
                    </div>

                    <button class="contact-submit-button">Submit</button>
                </form>
            </div>
            <img src="${0, (/*@__PURE__*/$parcel$interopDefault($25c9V))}" class="contact-side-icon">
        </div>

        <div class="contact-information-container">
            <p class="contact-information-title">CONTACT INFORMATION</p>
            <div class="contact-details-container">
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($k5z4A))}"> #8/25, 2nd & 3rd Floor, Kambar Street, Alandur, Chennai - 600 016</p>
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($flovY))}"> reachus@virtualmaze.co.in</p>
                <p class="footer-tab-body"><img src="${0, (/*@__PURE__*/$parcel$interopDefault($5AxGM))}"> +91 90921 90321</p>
            </div>
        </div>

        <iframe style="width: 100%;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15549.788523735537!2d80.19645827526911!3d13.007173759492792!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267c99154969b%3A0x1892d69b6e39e850!2sVirtualMaze!5e0!3m2!1sen!2sin!4v1702966608642!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>

    <div class="contact-submit-success-parent-container" style="display: none;">
        <div class="contact-submit-success-inner-container">
            <div class="contact-submit-success-container">
                <img src="${0, (/*@__PURE__*/$parcel$interopDefault($bmmz0))}" class="contact-success-icon">
                <p class="contact-thank-you-header">Thank you registering with us.</p>
                <p>Your application has been successfully submitted. Our representative will get in touch with you</p>
                <button class="success-ok-button">Ok</button>
            </div>
        </div>
    </div>
    
</div>
    `;
        return this.container;
    };
    addEvents(container) {
        let home = container.querySelector("#home-nav");
        let contactNav = container.querySelector("#contact-nav");
        let contacts = container.querySelectorAll(".contact-us-menu-button");
        home.addEventListener("click", ()=>{
            container.querySelector(".contact-us-page-container").style.display = "none";
            container.querySelector(".home-page-container").style.display = "block";
            home.classList.add("navbar-active-link");
            contactNav.classList.remove("navbar-active-link");
        });
        contacts.forEach((contact)=>{
            contact.addEventListener("click", ()=>{
                container.querySelector(".contact-us-page-container").style.display = "block";
                container.querySelector(".home-page-container").style.display = "none";
                home.classList.remove("navbar-active-link");
                contactNav.classList.add("navbar-active-link");
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            });
        });
        document.getElementById("contactForm").addEventListener("submit", async function(event) {
            event.preventDefault();
            const formData = {
                name: container.querySelector("#fullName").value,
                email: container.querySelector("#email").value,
                phone: container.querySelector("#phone").value,
                subject: container.querySelector("#subject").value,
                message: container.querySelector("#message").value
            };
            const url = (0, $dUT0w.default)["proxyUrl"] + `/contactUs`;
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(formData)
                });
                const jsonRes = await response.json();
                if (!jsonRes.success) ;
                else {
                    container.querySelector(".contact-submit-success-parent-container").style.display = "flex";
                    document.querySelector(".landing-page-main-container").style.overflow = "hidden";
                    container.querySelector("#fullName").value = "";
                    container.querySelector("#email").value = "";
                    container.querySelector("#phone").value = "";
                    container.querySelector("#subject").value = "";
                    container.querySelector("#message").value = "";
                }
            } catch (err) {
                console.error("Error:", err);
            }
        });
        let success = document.querySelector(".success-ok-button");
        success.addEventListener("click", ()=>{
            container.querySelector(".contact-submit-success-parent-container").style.display = "none";
            document.querySelector(".landing-page-main-container").style.overflow = "unset";
        });
        let hamburger = container.querySelector(".hamburger-icon");
        let navbar = container.querySelector(".navbar-link-header");
        hamburger.addEventListener("click", ()=>{
            if (hamburger.src.includes((0, (/*@__PURE__*/$parcel$interopDefault($cuiEO))))) {
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($8NNKi)));
                navbar.classList.add("hamburger-navbar-link-header");
            } else {
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($cuiEO)));
                navbar.classList.remove("hamburger-navbar-link-header");
            }
        });
        let navbarLink = container.querySelectorAll(".navbar-link");
        navbarLink.forEach((navabarOne)=>{
            navabarOne.addEventListener("click", ()=>{
                navbar.classList.remove("hamburger-navbar-link-header");
                hamburger.src = (0, (/*@__PURE__*/$parcel$interopDefault($cuiEO)));
            });
        });
    }
}
var $105fe560979385a8$export$2e2bcd8739ae039 = $105fe560979385a8$var$Page;


new (0, $105fe560979385a8$export$2e2bcd8739ae039)({});


//# sourceMappingURL=privacy.bc4d721e.js.map
